import React from "react";
import Hero from "./Hero";
import PremiumMembership from "./PremiumMembership";
import Header from "./Header";
import MembershipSteps from "./MembershipSteps";
import PricingComparison from "./PricingComparison";
import CommunitySection from "./CommunitySection";

const FullHome: React.FC = () => {

    return (
        <>
            <Header></Header>
            <Hero></Hero>
            <PremiumMembership></PremiumMembership>
            <MembershipSteps></MembershipSteps>
            <PricingComparison></PricingComparison>
            <CommunitySection></CommunitySection>


        </>
    );
};

export default FullHome;